/* eslint-disable */
import { ACustomClient as Client } from '@/support/ACustomClient';
import { Token } from '@/support/Token';
// import { Config } from '@/core';
// import { TC, currentLanguage } from '@/i18n';
import store from '@/store';
import { identifyHostname } from './support/Client';
// import { Dialog } from '@/dialog';
const applicationId = 'atabase3.app';
export const authorizedHeaderResolver = () => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': applicationId,
    'X-App-Platform': 'web',
    'Authorization': Token.getAccessToken() ? `Bearer ${Token.getAccessToken()}` : '',
    // 'accept-language': currentLanguage(),
});
export const environmentBaseUrlResolverFactory = (key) => () => {
    if (Client.isDebug) {
        console.log('key', key);
        // console.log(`${Config.get(key)}`);
    }
    if (key === 'APP_HOST_RPC') {
        return `${identifyHostname()}/rpc`;
    }
    // return `${Config.get(key)}`.replace('*', Config.getWildcard());
    return '';
};
export const responseResolver = (response) => Promise.resolve(response.data);
export const errorResolver = async (error, client, request) => {
    const logPrefix = '[NETWORK-RESPONSE]';
    if (!error.response) {
        store.dispatch('AppStore/setIsOffline', true);
        return Promise.reject(error);
    }
    if (error.response.status) {
        Client.debug(`${logPrefix} HTTP ${error.response.status}`);
        const response = error.response;
        switch (error.response.status) {
            case 401: {
                store.dispatch('AppStore/setIsAccessDenied', true);
                return Promise.resolve(error);
            }
            case 403: {
                // Dialog.warning({ title: response.statusText, text: (response.data as any).message });
                break;
            }
            case 404: {
                // Dialog.warning({ title: TC('Page / Resource not found'), text: (response.data as any).message });
                break;
            }
            case 422: {
                const errors = [];
                Object.keys(response.data.errors).forEach((name) => {
                    errors.push(response.data.errors[name]);
                });
                const message = errors.join('<br />');
                // Dialog.warning({ title: response.statusText, text: message });
                return Promise.reject(error);
            }
            case 500:
            default: {
                // Dialog.error({ title:  TC('Fatal error'), text: TC('Please contact the helpdesk for this problem.') });
                return Promise.reject(error);
            }
        }
    }
    if (error) {
        Client.debug(`${logPrefix} ${JSON.stringify(error)} ${error}`);
    }
    return Promise.reject(error);
};
export class RpcClient extends Client {
    constructor() {
        super(...arguments);
        this.$options = {
            baseUrl: '',
            headers: {},
            headerResolver: authorizedHeaderResolver,
            baseUrlResolver: environmentBaseUrlResolverFactory('APP_HOST_RPC'),
            errorResolver,
            responseResolver,
        };
    }
    execute(signature, payload) {
        return this.call('POST', '', {
            signature,
            body: payload,
        });
    }
}
